import { CLOUDFRONT_GOVIP_ROOT_URL, CLOUDFRONT_LANDING_PAGE_ROOT_URL } from '@shared/config/constants/app';

const step1 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/step1-icon.svg`;
const step2 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/step2-icon.svg`;
const step3 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/step3-icon.svg`;
const step4 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/step4-icon.svg`;

const step1White = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/step1-white-min.webp`;
const step2White = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/step2-white-min.webp`;
const step3White = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/step3-white-min.webp`;

const flagUae = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/flag-uae.svg`;
const flagBahrain = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/flag-bahrain.svg`;
const flagQatar = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/flag-qatar.svg`;
const flagEgypt = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/flag-egypt.svg`;
const flagJordan = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/flag-jordan.svg`;
const flagTunisia = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/flag-tunisia.svg`;
const flagIraq = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/flag-iraq.svg`;
const flagPalestine =
  `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/flag-palestine.svg`;
const flagSaudi = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/flag-ksa.svg`;
const flagKuwait = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/flag-kuwait.svg`;

const appleStore = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/appstore-cta.svg`;
const playStore = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/googleplay-cta.svg`;

const appleStoreWhite =
  `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/appstore-white.webp`;
const playStoreWhite =
  `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/googleplay-white.webp`;

const fb = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/fb.svg`;
const insta = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/insta.svg`;
const twitter = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/twitter.svg`;

const ccImg = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/cc-img.webp`;
const applePay = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/apple-pay.webp`;

const shield = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/shield.svg`;

const blueCheck = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/check-icon.svg`;

const cat1 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/cat1.webp`;
const cat2 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/cat2.webp`;
const cat3 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/cat3.webp`;
const cat4 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/cat4.webp`;
const cat5 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/cat5.webp`;
const cel1 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/cel1.webp`;
const cel2 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/cel2.webp`;
const cel3 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/cel3.svg`;
const cel4 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/cel4.webp`;
const cel5 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/cel5.webp`;
const cel6 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/cel6.webp`;
const cel7 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/cel7.webp`;

const comp1 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/comp1.svg`;
const comp2 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/comp2.svg`;
const comp3 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/comp3.svg`;
const comp4 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/comp4.svg`;
const comp5 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/s/comp5.webp`;

const operatorIcon = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/operator-icon.webp`;

const promo = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/promo.webp`;
const promoreward = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/promoreward.webp`;
const promoloader = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/loader2.gif`;

const exit = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/exit.webp`;

const greenCheckMark = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/green-check.webp`;
const blueCheckMark = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/blue-check.webp`;

const phone14prouae = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/banners/iPhone_14_Pro_uae.webp`

const btnExpand = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/btn_expand.svg`

const vipWhiteIcon = `${CLOUDFRONT_GOVIP_ROOT_URL}/icons/vip_text.svg`

const customer_p1 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/customer_p1.webp`
const customer_p2 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/customer_p2.webp`
const customer_p3 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/customer_p3.webp`

const customer_review_star = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/customer_reviews_filled_star.svg`
const blue_text_brackets = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/blue_comments_brackets.svg`

const voice_rooms = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/phone_voice_rooms_v3_new.png`
const app_feature_new_2 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/live_video_v3_new.png`
const app_feature_new_3 = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/shop_image_v3_new.png`

const AppleStoreLogo = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/app_store_text_logo.webp`;
const GooglePlayLogo = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/google_play_text_logo.webp`;
const filled_store_star = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/filled_store_star.svg`;
const appStore_filled_stare = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/appStore_filled_stare.svg`;
const googlePlay_filled_stare = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/googlePlay_filled_star.svg`;

const card_filed_question_mark = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/card_filed_question_mark.svg`
const ic_amex_new = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_amex_new.svg`
const ic_card_new = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_card_new.svg`
const ic_check_blue = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_check_blue.svg`
const ic_lock_new = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_lock_new.svg`
const ic_mastercard_new = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_mastercard_new.svg`
const ic_recaptcha = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_recaptcha.svg`
const ic_shield_blue = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_shield_blue.svg`
const ic_stripe_new = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_stripe_new.svg`
const ic_visa_new = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_visa_new.svg`
const ic_error_new = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_error_new.svg`
const ic_generic_error = `${CLOUDFRONT_GOVIP_ROOT_URL}/icons/ic_error.svg`

const find_card_number = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/card_number_ic_en_v3.svg`
const find_card_number_ar = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/card_number_ic_ar_v3.svg`
const find_cvv = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/cvv_ic_v3.svg`

const app_store_confirmation_logo = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/mobile_app_store_image.webp`
const google_paly_confirmation_logo = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/optimized-png/mobile_google_play_image.webp`

const ic_step_done_blue = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_step_done_blue.svg`

const ic_viplogo_tv = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/ic_viplogo_tv.svg`

const not_found_page_dark_background = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/bg_404_desk_dark.svg`;
const not_found_page_dark_background_mobile = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/bg_404_mob_dark.svg`;

const not_found_page_white_background = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/bg_404_desk_white.svg`;
const not_found_page_white_background_mobile = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/bg_404_mob_white.svg`;

const processing_icon = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/processing_icon.svg`;
const vt1_phone = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/vt1_phone.svg`;
const red_button_corner = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/png/red_button_corner.png`;
const blue_background_blur = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/blue-background-blur.svg`;

const Icons = {
  step1,
  step2,
  step3,
  step4,
  flagUae,
  flagBahrain,
  flagQatar,
  flagEgypt,
  flagJordan,
  flagTunisia,
  flagIraq,
  flagPalestine,
  flagSaudi,
  flagKuwait,
  appleStore,
  playStore,
  fb,
  insta,
  twitter,
  ccImg,
  applePay,
  shield,
  step1White,
  step2White,
  step3White,
  appleStoreWhite,
  playStoreWhite,

  blueCheck,
  cat1,
  cat2,
  cat3,
  cat4,
  cat5,
  cel1,
  cel2,
  cel3,
  cel4,
  cel5,
  cel6,
  cel7,

  comp1,
  comp2,
  comp3,
  comp4,
  comp5,

  customer_p1,
  customer_p2,
  customer_p3,

  customer_review_star,
  blue_text_brackets,

  operatorIcon,
  promo,
  promoreward,
  promoloader,
  exit,
  greenCheckMark,
  blueCheckMark,

  phone14prouae,
  btnExpand,

  voice_rooms,
  app_feature_new_2,
  app_feature_new_3,

  card_filed_question_mark,
  ic_amex_new,
  ic_card_new,
  ic_check_blue,
  ic_lock_new,
  ic_mastercard_new,
  ic_recaptcha,
  ic_shield_blue,
  ic_stripe_new,
  ic_visa_new,
  ic_error_new,

  vipWhiteIcon,

  AppleStoreLogo,
  GooglePlayLogo,
  filled_store_star,
  appStore_filled_stare,
  googlePlay_filled_stare,
  ic_generic_error,
  find_card_number,
  find_card_number_ar,
  find_cvv,

  app_store_confirmation_logo,
  google_paly_confirmation_logo,

  ic_step_done_blue,
  ic_viplogo_tv,

  not_found_page_dark_background,
  not_found_page_dark_background_mobile,
  not_found_page_white_background,
  not_found_page_white_background_mobile,

  processing_icon,
  vt1_phone,
  red_button_corner,
  blue_background_blur,
};

export default Icons;
